import { Grid } from "@mui/material";
import { withStyles, WithStyles } from "@mui/styles";
import { PaginationStyleClasses } from "assets/jss/common-styles";
import Pagination, { PaginationProps } from "components/FlatPagination";
import * as React from "react";

type Props = PaginationProps & WithStyles<typeof PaginationStyleClasses>;

const MuiPagination: React.FC<Props> = (props) => {
    return (
        <Grid container justifyContent="space-between" alignItems="center" >
            <Grid item xs style={{ textAlign: "center" }}>
                <Pagination {...props}
                    classes={
                        {
                            textPrimary: props.classes.textPrimary,
                            textSecondary: props.classes.textSecondary
                        }
                    }
                />
            </Grid>
        </Grid>
    )
}

export default withStyles(PaginationStyleClasses)(MuiPagination);
